/**
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   user.js
 */

import { localStorageSingleton as LocalStorage } from '../shared/utils/localStorage.singleton'

export interface PartialUser {
  email?: string | null
  first_name?: string | null
  last_name?: string | null
  long_name?: string | null
  phone?: string | null
  tenant_profile?: { move_in?: string | null } | null
}

/**
 * For djz backwards compatibility:
 * stores `user` as `messagingUser` in local storage variable
 *
 * @param user
 */
const saveMessagingUserToLocalStorage = (user: PartialUser) => {
  const { email, first_name: firstName, last_name: lastName, long_name: longName, phone } = user
  const messagingUser = LocalStorage.getx('messagingUser')
  const name = longName || `${firstName || ''} ${lastName || ''}`.trim()
  const updatedMessagingUser = Object.assign({}, messagingUser, {
    name,
    email,
    phone,
  })

  LocalStorage.setx('messagingUser', updatedMessagingUser)
}

/**
 * For djz backwards compatibility:
 * Stores `move_in` in `userTour` in local storage variable.
 *
 * @param user
 */
const saveUserTourToLocalStorage = (user?: PartialUser) => {
  if (user?.tenant_profile) {
    const { move_in: moveIn } = user.tenant_profile
    const userTour = LocalStorage.getx('userTour')
    const updatedUserTour = Object.assign({}, userTour, { moveIn })

    LocalStorage.setx('userTour', updatedUserTour)
  }
}

export const saveUserToLocalStorage = (user?: PartialUser) => {
  if (user) {
    LocalStorage.set('user', user)

    // TODO: once we fully sunset djz, the following is unnecessary.
    saveMessagingUserToLocalStorage(user)
    saveUserTourToLocalStorage(user)
  }
}

export const removeUserFromLocalStorage = () => {
  LocalStorage.del('user')
  // NOTE: we need to delete additional local storage variable for djz
  LocalStorage.del('messagingUser')
  LocalStorage.del('userTour')
}
